<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <h5>Task-uri</h5>
        </div>
        <div class="card-body tab2-card">
          <form [formGroup]="taskForm" class="needs-validation" novalidate>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Numar</label>
                <input class="form-control" type="text" formControlName="number">
              </div>
              <div class="col-xl-6 col-md-3">
                <label>Task</label>
                <select class="form-control digits" formControlName="type">
                  <option *ngFor="let option of taskTypeOptions| keyvalue: originalOrder" [value]="option.key">
                    {{ option.value }} </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>POD/CLC</label>
                <input class="form-control" type="text" formControlName="code">
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Status</label>
                <select class="form-control digits" formControlName="status">
                  <option *ngFor="let option of statusOptions" [value]="option">
                    {{ option }} </option>
                </select>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Data primire</label>
                <input class="form-control" type="date" formControlName="receiveDate" onkeydown="return false">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet</label>
                <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate</label>
                <select class="form-control digits" formControlName="city">
                  <option *ngFor="let city of cities" [value]="city.id">
                    {{ city.name }} </option>
                </select>
              </div>
              <div class="col-xl-auto col-md-auto" style="margin-top: auto">
                <button type="button" class="btn btn-primary" (click)="searchTasks(0)">
                  Cauta
                </button>
              </div>
            </div>
          </form>
          <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
            <div class="category-table custom-datatable">
              <div class="table-responsive">
                <ng2-smart-table [settings]="taskDisplaySettings" [source]="tasks?.content"
                  (custom)="onCustomActionTasks($event)"></ng2-smart-table>
              </div>
            </div>
          </div>
          <div *ngIf="tasks?.totalElements">
            <h4 class="pagination justify-content-center">
              Total task-uri: {{tasks?.totalElements}}
            </h4>
            <ul class="pagination justify-content-center">
              <li class="page-item" (click)="previousPage()">
                <a class="page-link" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li *ngFor="let page of paginationTasks" [ngClass]="page.className" (click)="changePage(page)">
                <a class="page-link">{{page.pageNumber + 1}}</a>
              </li>
              <li class="page-item" (click)="nextPage()">
                <a class="page-link" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->